import React, { useEffect, useState } from 'react'
import styles from './DigitalInstrumentalCluster_Coral.module.css'
import useHttp from "../../../hook/use-http";
import { API_URL_MAIN } from "../../../constants/driveglobalfilterinitialstates_coral";
import { formatTo12Hour, subtractTime } from "../../../util/dateTimeUtils";

function VehicleOperations_Coral(props) {
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [countData, setCountData] = useState({});

  const now = new Date();
  // Get 30 minutes ago
  const thirtyMinutesAgo = subtractTime(now, { minutes: 30 });
  const thirtyMinuteMinus = formatTo12Hour(thirtyMinutesAgo);
  // Get 20 days ago
  const twentyDaysAgo = subtractTime(now, { days: 20 });
  const twentyDaysMinus = formatTo12Hour(twentyDaysAgo);

  useEffect(() => {
    fetchData(
      {
        url: API_URL_MAIN + "coral_dic/" + props.oneCard.apiEnd + "_cnt",
        body: { filterdata: props.gloablfilter, thirtyMinuteMinus: thirtyMinuteMinus, twentyDaysMinus: twentyDaysMinus },
      },
      appyData
    );
  }, [props.gloablfilter]);

  const appyData = (data) => {
    setCountData(data);
  };

  return (
    <div className="py-2 col">
      <p className={`h5 m-0 ${styles.fw_600} ${styles.textColorGreen}`}>{countData[props.oneCard.apiEnd]?.doc_count}</p>
      <p className="m-0">
        <small className={`text-muted ${styles.fw_600}`}>{props.oneCard.cNm}</small>
      </p>
    </div>
  )
}

export default VehicleOperations_Coral